import React, { useEffect, useState } from 'react';
import "./ExpiringInventoryReport.scss";
import useReports from '../../../Hooks/useReports';
import Loading from '../../../components/LoadingPage/Loading';
import { manageLineBreakFromString } from '../../../utils/commonUtils';

interface ExpiringInventoryReportRes {
    message: string;
    status: boolean;
}

const ExpiringInventoryReport: React.FC = () => {
    const [reportData, setReportData] = useState<ExpiringInventoryReportRes | undefined>();
    const { expiringInventoryReportAPI, expiringInventoryReportLoading } = useReports();

    useEffect(() => {
        fetchExpiringInventoryReport();
    }, []);

    const fetchExpiringInventoryReport = async () => {
        const res = await expiringInventoryReportAPI({});
        setReportData(res);
    }

    

    return (
        <div className='expiring-inventory-report-wrapper'>
            {expiringInventoryReportLoading ? <Loading /> : null}
            <div
                className={`report-content ${reportData?.status ? 'success-txt' : 'error-txt'}`}
                dangerouslySetInnerHTML={{ __html: manageLineBreakFromString(reportData?.message ?? "") }}
            />
        </div>
    )
}

export default ExpiringInventoryReport;